import CustomPieChart from './pieChart'
export default CustomPieChart
